import { render, staticRenderFns } from "./paciente-card.vue?vue&type=template&id=24202e86&"
import script from "./paciente-card.vue?vue&type=script&lang=js&"
export * from "./paciente-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports